import { atom } from "jotai"

import type { InferReturn } from "~/@types/generics"
import type { serializeCollectionTree } from "~/managers/CollectionsTreeManager/_data/serializer"

export const collectionTreeAtom = atom<InferReturn<typeof serializeCollectionTree>>([])
